import { render, staticRenderFns } from "./TicketRequestListTable.component.vue?vue&type=template&id=11791935"
import script from "./TicketRequestListTable.component.vue?vue&type=script&lang=js"
export * from "./TicketRequestListTable.component.vue?vue&type=script&lang=js"
import style0 from "./TicketRequestListTable.component.vue?vue&type=style&index=0&id=11791935&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports